import uuid from 'uuid/v1'


export function createUniqueId() {
  return uuid()
}